import { render } from "./ApproveLiquidation.vue?vue&type=template&id=b0ea0df0"
import script from "./ApproveLiquidation.vue?vue&type=script&lang=js"
export * from "./ApproveLiquidation.vue?vue&type=script&lang=js"

import "./ApproveLiquidation.vue?vue&type=style&index=0&id=b0ea0df0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__